





















import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import HMS3ImageUploader from '@/web/components/common/HMS3ImageUploader.vue';

export default Vue.extend({
  name: 'HMVueEditorAddImageModal',
  components: {
    HMS3ImageUploader,
    ValidationObserver,
  },
  data() {
    return {
      url: '',
    };
  },
  methods: {
    selectImageUrl() {
      this.$parent.$emit('selectImageUrl', this.url);
      this.$emit('close');
    },
  },
});
